import * as Config from '../config/Config';
import * as User from '../helpers/User';
import * as Common from '../helpers/Common';

export function setNewPost(newPost) {
    return { type: "SET_NEW_POST", newPost};
}

export function getNewPost() {
    return dispatch => {
        let learnerID = Common.getUserData("id", true);
        let productID = Common.getUserData("productID", true);
        let fullName = Common.getUserData("fullName", true);
        let blog = Common.getUserData("blog", true);
        let library = Common.getUserData("library", true);
        let poll = Common.getUserData("poll", true);
        let forum = Common.getUserData("forum", true);
        let corpID = Common.getUserData("corporateID", true);
        let pinNo = Common.getUserData("pinNo", true);
        let pinID = Common.getUserData("pinID", true);
        let role = Common.getUserData("role", true);

        //For Temporary new post comment 10-05-2019

        fetch(Config.domainUrl+'left/new-post', {
                method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'Authorization':'Bearer ' +Common.getTokenData()
                },

                  body: JSON.stringify({
                    learner_id:learnerID,lr_product:productID,fullName:fullName,blog:blog,library:library,poll:poll,forum:forum,corpID:corpID,pinID:pinID,role:role,pinNo:pinNo,
                  })
                }).then((response) => response.json())
               .then((responseJson) => {
                    // Common.reactLoader("hide");
                    dispatch(setNewPost(responseJson.posts));
                   

                }).catch(error => {
                    console.error(error);
                    
                });    
     
    };
}


// WEBPACK FOOTER //
// ./src/actions/newPostAction.js